function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance"); }

function _iterableToArray(iter) { if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import EBPropTypes from 'js-utils/prop-types';
import FieldWrapper from './FieldWrapper';
import Icon from '../icon/Icon';
import SelectSuffix from './_internals/SelectSuffix';
import { getInitialValue } from '../inputs/utils';
import { getAdditionalProps } from '../utils/propTypes';
import * as constants from './constants';
import ChevronDownChunkySvg from '../iconography/icons/ChevronDownChunky';

var _getOptions = function _getOptions(values, selectedValue) {
  // Build up the list of optionComponents and determine the selected
  // display in one iteration. We're determining this derived value here
  // instead of storing it in state
  var selectedDisplay;
  var optionComponents = values.map(function (_ref) {
    var value = _ref.value,
        display = _ref.display,
        isDisabled = _ref.isDisabled,
        key = _ref.key;
    var disabled; // setting this value is a side effect of the single iteration

    if (value === selectedValue) {
      selectedDisplay = display;
    }

    if (isDisabled) {
      disabled = 'disabled';
    }

    return React.createElement("option", {
      disabled: disabled,
      key: key || value,
      value: value,
      "data-spec": "select-option"
    }, display);
  });
  return {
    selectedDisplay: selectedDisplay,
    optionComponents: optionComponents
  };
};

var SelectElement = function SelectElement(_ref2) {
  var disabled = _ref2.disabled,
      hasError = _ref2.hasError,
      id = _ref2.id,
      required = _ref2.required,
      name = _ref2.name,
      onBlur = _ref2.onBlur,
      onChange = _ref2.onChange,
      onFocus = _ref2.onFocus,
      selectedValue = _ref2.selectedValue,
      values = _ref2.values,
      dataAutomation = _ref2.dataAutomation,
      style = _ref2.style,
      suffix = _ref2.suffix,
      extraAttrs = _objectWithoutProperties(_ref2, ["disabled", "hasError", "id", "required", "name", "onBlur", "onChange", "onFocus", "selectedValue", "values", "dataAutomation", "style", "suffix"]);

  var _getOptions2 = _getOptions(values, selectedValue),
      selectedDisplay = _getOptions2.selectedDisplay,
      optionComponents = _getOptions2.optionComponents;

  var requiredIndicator = null;

  if (required && style === constants.STYLE_BASIC) {
    requiredIndicator = React.createElement("span", {
      className: "eds-label__required-indicator eds-text-bm"
    }, " *");
  }

  return React.createElement("div", {
    className: "eds-field-styled__select-wrapper"
  }, React.createElement("span", {
    className: "eds-field-styled__select-value"
  }, React.createElement("span", {
    className: "eds-field-styled__select-value-text"
  }, selectedDisplay, requiredIndicator), React.createElement(SelectSuffix, {
    suffix: suffix
  }), React.createElement("span", {
    className: "eds-field-styled__select-icon"
  }, React.createElement(Icon, {
    type: React.createElement(ChevronDownChunkySvg, null)
  }))), React.createElement("select", _extends({
    "aria-invalid": hasError,
    "aria-required": required,
    className: "eds-field-styled__input eds-field-styled__select",
    "data-automation": dataAutomation,
    role: "listbox",
    value: selectedValue,
    disabled: disabled,
    id: id,
    name: name,
    onBlur: onBlur,
    onChange: onChange,
    onFocus: onFocus
  }, extraAttrs), optionComponents));
};

var SelectField =
/*#__PURE__*/
function (_PureComponent) {
  _inherits(SelectField, _PureComponent);

  function SelectField(props) {
    var _this;

    _classCallCheck(this, SelectField);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(SelectField).call(this, props));
    var value = props.value,
        defaultValue = props.defaultValue,
        placeholder = props.placeholder,
        values = props.values;
    _this.state = {
      isActive: false,
      selectedValue: getInitialValue(value || defaultValue, values, placeholder)
    };
    return _this;
  }

  _createClass(SelectField, [{
    key: "componentWillReceiveProps",
    value: function componentWillReceiveProps(_ref3) {
      var value = _ref3.value,
          values = _ref3.values,
          placeholder = _ref3.placeholder;

      // allows setting an existing `input` element's value via props from a parent
      if (value !== undefined) {
        this.setState({
          selectedValue: getInitialValue(value, values, placeholder)
        });
      }
    }
  }, {
    key: "_handleBlur",
    value: function _handleBlur() {
      this.setState({
        isActive: false
      });

      if (this.props.onBlur) {
        this.props.onBlur(this.state.selectedValue);
      }
    }
  }, {
    key: "_handleChange",
    value: function _handleChange(e) {
      var _e$target = e.target,
          value = _e$target.value,
          selectedIndex = _e$target.selectedIndex;
      var values = this.props.values;
      var selectedValue = value;

      if (values.length && values[selectedIndex]) {
        selectedValue = values[selectedIndex].value;
      }

      this.setState({
        selectedValue: selectedValue
      });

      if (this.props.onChange) {
        this.props.onChange(selectedValue, selectedIndex);
      }
    }
  }, {
    key: "_handleFocus",
    value: function _handleFocus() {
      this.setState({
        isActive: true
      });

      if (this.props.onFocus) {
        this.props.onFocus(this.state.selectedValue);
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
          annotationNote = _this$props.annotationNote,
          bottomSpacing = _this$props.bottomSpacing,
          disabled = _this$props.disabled,
          hasError = _this$props.hasError,
          id = _this$props.id,
          label = _this$props.label,
          required = _this$props.required,
          name = _this$props.name,
          placeholder = _this$props.placeholder,
          suffix = _this$props.suffix,
          style = _this$props.style,
          borderType = _this$props.borderType,
          dataSpec = _this$props['data-spec'],
          dataAutomation = _this$props['data-automation'];
      var values = this.props.values;
      var _this$state = this.state,
          isActive = _this$state.isActive,
          selectedValue = _this$state.selectedValue;
      var extraAttrs = getAdditionalProps(this);
      var wrapperDataAutomation = dataAutomation ? "".concat(dataAutomation, "-wrapper") : 'select-field-wrapper';

      if (placeholder) {
        values = [// placeholder is not natively supported in dropdowns
        // to achieve the same functionality, we place an empty disabled value as the first option in the list
        {
          display: placeholder,
          value: constants.PLACEHOLDER_DUMMY_VALUE,
          isDisabled: true
        }].concat(_toConsumableArray(values));
      }

      return React.createElement(FieldWrapper, {
        annotationNote: annotationNote,
        bottomSpacing: bottomSpacing,
        disabled: disabled,
        hasError: hasError,
        id: id,
        isActive: isActive,
        label: label,
        required: required,
        style: style,
        value: selectedValue,
        dataSpec: dataSpec,
        dataAutomation: wrapperDataAutomation,
        borderType: borderType
      }, React.createElement(SelectElement, _extends({}, extraAttrs, {
        dataAutomation: dataAutomation,
        disabled: disabled,
        hasError: hasError,
        id: id,
        name: name,
        required: required,
        onBlur: this._handleBlur.bind(this),
        onChange: this._handleChange.bind(this),
        onFocus: this._handleFocus.bind(this),
        selectedValue: selectedValue,
        values: values,
        style: style,
        suffix: suffix
      })));
    }
  }]);

  return SelectField;
}(PureComponent);

_defineProperty(SelectField, "propTypes", {
  /**
   * Text to be displayed as the label of the select element.
   * Required for accessibility reasons but it can be hidden.
   */
  label: PropTypes.node.isRequired,

  /**
   * Array of formatted options
   */
  values: constants.VALUES_PROP_TYPE.isRequired,

  /**
   * Text to be displayed as annotation below the select element.
   */
  annotationNote: PropTypes.node,

  /**
   * The amount of spacing for the bottom
   */
  bottomSpacing: PropTypes.number,

  /**
   * Default value of select element.
   * This is the initial value.
   * After the select input has been rendered the first time,
   * if the default value changes, it will *not* update the input.
   */
  defaultValue: PropTypes.string,

  /**
   * Sets disabled attribute to the select element.
   */
  disabled: PropTypes.bool,

  /**
   * Field style chosen for the input. It can be one of: 'static' or 'basic'.
   * Static: the label and the placeholder are always in place and visible.
   * Basic: the label is hidden but still present for accessibility purposes.
   */
  style: PropTypes.oneOf(constants.SELECT_STYLES),

  /**
   * Field border type chosen for the input. It can be one of: 'default', 'simple' or 'none'.
   * Default: the border changes from grey on idle to a coloured state on focus.
   * Simple: the border preserves its grey colour and has no rounded corners.
   * None: the border is hidden and is replaced by a line below the input to point the writtable area.
   */
  borderType: PropTypes.oneOf(constants.BORDER_TYPES),

  /**
   * Sets error state (adds error classes and aria-invalid).
   */
  hasError: PropTypes.bool,

  /**
   * Sets the id for the select element and htmlFor attribute for the label.
   */
  id: PropTypes.string,

  /**
   * Marks the select as required (adds * and aria-required).
   */
  required: PropTypes.bool,

  /**
   * Name of select element.
   */
  name: PropTypes.string,

  /**
   * {function} onBlur
   * By default sets isActive state to false and delegates the control to
   * the onBlur function passed as prop.
   */
  onBlur: PropTypes.func,

  /**
   * {function} onChange
   * By default sets the select value to the state and delegates
   * the control to the onChange function passed as prop.
   */
  onChange: PropTypes.func,

  /**
   * {function} onFocus
   * By default sets isActive state to true and delegates the control to
   * the onFocus function passed as prop.
   */
  onFocus: PropTypes.func,

  /**
   * Text to be displayed when no option is selected.
   * if you need a blank option that is selectable
   *    - remove the placeholder prop
   *    - add a new value list with the proper display text and empty value
   */
  placeholder: EBPropTypes.translation,

  /**
   * Node to be displayed to the right of the select field but to the left of the chevron.
   */
  suffix: PropTypes.node,

  /**
   * Current selected value.
   */
  value: PropTypes.string,

  /**
   * Identifier for unit tests.
   */
  'data-spec': PropTypes.string,

  /**
   * Identifier for automation tests
   */
  'data-automation': PropTypes.string
});

_defineProperty(SelectField, "defaultProps", {
  bottomSpacing: 2,
  defaultValue: '',
  style: constants.STYLE_STATIC,
  borderType: constants.BORDER_DEFAULT,
  'data-spec': 'select-field'
});

export { SelectField as default };